import { PRESETS_CODES, CONFLICT_POLICY_TO_CLONING_PRESET } from './presetsConfig'

export const PERSONAL_SETTINGS_MAPPING = {
	START_DAY: 'start_day',
	SINGLE_TEST: 'single_test',
	MULTIPLE_TEST: 'multiple_test',
}

export const PERSONAL_SETTINGS_TO_PRESET_CODE = {
	[PERSONAL_SETTINGS_MAPPING.START_DAY]: PRESETS_CODES.PERSONAL_SETTINGS_START_DAY,
	[PERSONAL_SETTINGS_MAPPING.SINGLE_TEST]: PRESETS_CODES.PERSONAL_SETTINGS_SINGLE_TEST,
	[PERSONAL_SETTINGS_MAPPING.MULTIPLE_TEST]: PRESETS_CODES.PERSONAL_SETTINGS_MULTIPLE_TEST,
}

export const PERSONAL_SETTINGS_TO_PRESET_CONFLICT_POLICY = {
	[PERSONAL_SETTINGS_MAPPING.START_DAY]: CONFLICT_POLICY_TO_CLONING_PRESET.REPLACE_ALL,
	[PERSONAL_SETTINGS_MAPPING.SINGLE_TEST]: CONFLICT_POLICY_TO_CLONING_PRESET.REPLACE_ALL,
	[PERSONAL_SETTINGS_MAPPING.MULTIPLE_TEST]: CONFLICT_POLICY_TO_CLONING_PRESET.ADD_IF_NOT_EXISTS,
}
